<template>
    <div class="Page">
        <Header Act="99" ref="Header"></Header>
        <div class="MaxWid">
            <!-- <div class="MarTop">
                <Banner></Banner>
            </div> -->
            <div class="MarTop">
                <div class="AboutPos">当前位置：个人中心</div>
                <div class="AboutDis">
                    <div class="AboutNav">
                        <div class="AboutNavItem" :class="{Act:i==1}" @click="TogglePage(1)"><i class="iconfont icon-guanliyuan_jiaoseguanli"></i>个人信息</div>
                        <div class="AboutNavItem" :class="{Act:i==2}" @click="TogglePage(2)"><i class="iconfont icon-pta-dashboard"></i>心理服务专业人员注册</div>
                        <!-- <div class="AboutNavItem" :class="{Act:i==10}" @click="TogglePage(10)"><i class="iconfont icon-pta-dashboard"></i>心理服务专业人员更新注册</div> -->
                        <div class="AboutNavItem" :class="{Act:i==3}" @click="TogglePage(3)"><i class="iconfont icon-fabuhezu"></i>心理服务专业机构注册</div>
                        <!-- <div class="AboutNavItem" :class="{Act:i==11}" @click="TogglePage(11)"><i class="iconfont icon-fabuhezu"></i>心理服务专业机构更新注册</div> -->
                        <!-- <div class="AboutNavItem" v-if="Data.is_review ==1" :class="{Act:i==8}" @click="TogglePage(8)"><i class="iconfont icon-jianyi"></i>我的评审列表</div> -->
                        <div class="AboutNavItem" v-if="Data.professional_is_review == 1 || Data.company_is_review == 1 || Data.project_is_review == 1" :class="{Act:i==8}" @click="TogglePage(8)"><i class="iconfont icon-jianyi"></i>我的评审列表</div>
                        <div class="AboutNavItem" v-if="Data.normal_register_professional == 1 || Data.normal_register_major_company == 1" :class="{Act:i==4}" @click="TogglePage(4)"><i class="iconfont icon-wodedingdan"></i>项目申请</div>
                        <div class="AboutNavItem" :class="{Act:i==9}" @click="TogglePage(9)"><i class="iconfont  icon-yonghuguanli"></i>我的推荐</div>
                        <div class="AboutNavItem" :class="{Act:i==5}" @click="TogglePage(5)"><i class="iconfont icon-wodedingdan"></i>我的订单</div>
                        <div class="AboutNavItem" :class="{Act:i==6}" @click="TogglePage(6)"><i class="iconfont icon-jianyi"></i>留言板</div>
                        <div class="AboutNavItem" :class="{Act:i==7}" @click="TogglePage(7)"><i class="iconfont icon-xiaoxi"></i>联系我们</div>
                        <div class="AboutNavItem" @click="UserOut"><i class="iconfont  icon-guanbi1"></i>安全退出</div>
                    </div>
                    <div class="AboutCont">
                        <Info v-if="i==1" @UpData="UpHead"></Info>
                        <Professional v-if="i==2" :TypeData="Data.is_register_professional" @TogglePage="TogglePage"></Professional>
                        <Agencies v-if="i==3" :TypeData="Data.is_register_major_company " @TogglePage="TogglePage"></Agencies>
                        <Publish v-if="i==4"></Publish>
                        <Order v-if="i==5"></Order>
                        <Suggest v-if="i==6"></Suggest>
                        <Contact v-if="i==7"  @TogglePage="TogglePage"></Contact>
                        <Review v-if="i==8"></Review>
                        <Recommend  v-if="i==9"></Recommend>
                        <!-- <Register1  v-if="i==10"></Register1>
                        <Register2  v-if="i==11"></Register2> -->
                    </div>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '@/components/header/head';
    import Footer from '@/components/header/footer';
    import Banner from '@/components/banner/Banner';
    import Info from '@/components/user/Info';
    import Contact from '@/components/user/Contact';
    import Agencies from '@/components/user/Agencies';
    import Order from '@/components/user/Order';
    import Professional from '@/components/user/Professional';
    import Publish from '@/components/user/Publish';
    import Suggest from '@/components/user/suggest';
    import Review from '@/components/user/Review';
    import Recommend from '@/components/user/Recommend';
    // import Register1 from '@/components/user/Register1';
    // import Register2 from '@/components/user/Register2';
    export default {
        components: {Header,Footer,Banner,Info,Contact,Agencies,Order,Professional,Publish,Suggest,Review,Recommend},
        data() {
            return {
                i:1,
                Data: "",
                UpDatas:false,
            }
        },
        mounted() {
            if(this.$route && this.$route.query.id) {
                this.i = this.$route.query.id;
            }
            this.GetData();
        },
        methods: {
            GetData(){
              this.$post("api/user/getUserInfo")
              .then(res => {
                   if(res.data.code == 1){
                       this.Data = res.data.data;
                       console.log(this.Data);
                   }else{
                       this.$message.error(res.data.msg)
                   }
              })  
            },
            TogglePage(i){
                this.i = i;
            },
            UserOut(){
                this.$confirm('确认是否退出', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$post('api/user/logout').then((res) => {
                        if (res.data.code == 1) {
                            localStorage.removeItem("User");
                            this.$message({ message: res.data.msg, type: 'success' });
                            this.GoPage('/Login')
                        }else{
                            this.$message({ message: res.data.msg, type: 'error' });
                        }
                    })
                })
            },
            UpHead(){
                this.$refs.Header.UpData();
            },
            //跳转
            GoPage(url) {
                this.$router.push({
                    path: url
                });
            },
            GoToOrder() {
                this.$emit('TogglePage', 5);
            },
        },
    }
</script>
<style scoped>
    .Page {
        background: #fff;
    }

    .BgColorBlue {
        background-color: #037dbe;
    }

    .BgColorYellow {
        background-color: #ed8404;
    }

    .BgColorGreen {
        background-color: #82ae1d;
    }

    .MarTop {
        margin-top: 20px;
    }
    .MaxWid {
        max-width: 1180px;
        padding: 0 10px;
        margin: 0 auto;
    }
    .AboutPos{
        padding: 20px 0;
        font-size: 12px;
        color: #999999;
    }
    .AboutDis{
        display: flex;
        margin-bottom: 30px;
    }
    .AboutNav{
        width: 250px;
        background: #0385EB;
        flex-shrink: 0;
    }
    .AboutNavItem{
        padding: 15px;
        font-size: 16px;
        color: #fff;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: left;
    }
    .AboutNavItem:hover,
    .AboutNavItem.Act{
        background: #fff;
        color: #0385EB;
    }
    .AboutNavItem .iconfont{
        font-size: 22px;
        margin-right: 10px;
    }
    .AboutCont{
        flex: 1;
        margin-left: 20px;
        min-width: 0;
        overflow: hidden;
    }
    @media only screen and (max-width: 550px){
        .AboutDis{
            display: block;
            margin-bottom: 30px;
        }
        .AboutNav{
            margin-bottom: 20px;
            overflow-x: auto;
            width: 100%;
            white-space: nowrap;
        }
        .AboutNavItem{
            padding: 15px;
            font-size: 16px;
            text-align: center;
            display: inline-block;
        }
        .AboutNavItem .iconfont{
            display: none;
        }
        .AboutCont{
            margin: 0;
        }
    }
</style>